"use client";
import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import "../Styles/Heropar.css";

export const Heropar = ({ products, heading = "About Us", description = "Learn more about our vision, mission, team, and the services we offer to drive innovation and excellence." }) => {
  const firstRow = products.slice(0, 5);
  const secondRow = products.slice(5, 10);
  const thirdRow = products.slice(10, 15);
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  const springConfig = { stiffness: 300, damping: 30, bounce: 100 };

  const translateX = useSpring(
    useTransform(scrollYProgress, [0, 1], [0, 600]),
    springConfig
  );
  const translateXReverse = useSpring(
    useTransform(scrollYProgress, [0, 1], [0, -600]),
    springConfig
  );
  const opacity = useSpring(
    useTransform(scrollYProgress, [0, 0.7], [0.7, 1]),
    springConfig
  );

  // Track screen width
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define animation ranges based on device width
  let translateYRange = [-420, 300];
  let rotateXRange = [15, 0];
  let rotateZRange = [20, 0];

  if (windowWidth <= 480) {
    // Mobile
    translateYRange = [50, 80];
    rotateXRange = [31, 0];
    rotateZRange = [0, 0];
  } else if (windowWidth <= 768) {
    // Tablet
    translateYRange = [10, 150];
    rotateXRange = [12, 0];
    rotateZRange = [12, 0];
  }

  const translateY = useSpring(
    useTransform(scrollYProgress, [0, 0.2], translateYRange),
    springConfig
  );

  const rotateX = useSpring(
    useTransform(scrollYProgress, [0, 0.2], rotateXRange),
    springConfig
  );

  const rotateZ = useSpring(
    useTransform(scrollYProgress, [0, 0.2], rotateZRange),
    springConfig
  );

  return (
    <div ref={ref} className="heropar-container">
      <Header heading={heading} description={description} />
      <motion.div style={{ rotateX, rotateZ, translateY, opacity }}>
        <motion.div className="heropar-row reverse">
          {firstRow.map((product, index) => (
            <ProductCard product={product} translate={translateX} key={index} />
          ))}
        </motion.div>
        <motion.div className="heropar-row">
          {secondRow.map((product, index) => (
            <ProductCard product={product} translate={translateXReverse} key={index} />
          ))}
        </motion.div>
        <motion.div className="heropar-row reverse">
          {thirdRow.map((product, index) => (
            <ProductCard product={product} translate={translateX} key={index} />
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
};

const Header = ({ heading, description }) => {
  return (
    <div className="aboutpg-header">
      <h1>{heading}</h1>
      <p>{description}</p>
    </div>
  );
};

const ProductCard = ({ product, translate }) => {
  return (
    <motion.div
      style={{ x: translate }}
      whileHover={{ y: -20 }}
      className="product-card"
    >
      <a href={product.link || "#"} className="product-link">
        <img
          src={product.thumbnail}
          alt={product.title || "Product Image"}
          className="product-image"
        />
      </a>
      <div className="product-overlay" />
      <h2 className="product-title">{product.title || ""}</h2>
    </motion.div>
  );
};
